import { getJobDetailsAction } from '../../actions/job-action/get-job-details.action';
import { getJobListWithCrewAction } from '../../actions/job-action/get-jobs-with-crew.action';

export const useAmsJobStore = () => {
  return {
    getJobListWithCrewAction,
    getJobDetailsAction,
  };
};
